<template>
  <div class="BookDetailWap">
    <!-- 头部 -->
    <top-header ref="myHeader">
      <template v-slot:bookTitle>
        <span
          style="width: calc(100% - 2.5rem);overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #333333;font-size: .28rem;"
        >
          {{ "/ " + BookTitle }}
        </span>
      </template>
    </top-header>
    <!-- banner -->
    <Banner />
    <!-- 面包屑 -->
    <div class="breadcrumbWrap">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item
          v-if="formRouterInfo.title"
          :to="{ path: formRouterInfo.path }"
        >
          {{ formRouterInfo.title }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ BookTitle }}</el-breadcrumb-item>
      </el-breadcrumb>
      <a
        href="https://www.tunnelling.cn/PMember/mybooklist.aspx"
        target="_blank"
      >
        我的知识平台
      </a>
    </div>
    <!-- 详情 -->
    <div class="BookContWrap">
      <!-- 左部分 -->
      <div class="leftContWrap">
        <!-- 书本介绍 -->
        <div class="bookIntrWrap">
          <div><img :src="BookImgUrl" alt="" :onerror="defaultImg" /></div>
          <div class="infoWrap">
            <h2>
              {{ BookTitle }}<img src="../../assets/img/page_icon_coupon.png" />
            </h2>
            <div class="infoText">
              <p ref="abstract">
                <span class="bookIntr" v-html="BookIntr"></span>
                <span class="moreIntr" v-if="showMoreText" @click="openMoreIntr">
                  更多
                </span>
              </p>
            </div>
            <div class="info_botWrap">
              <div class="bookPrice" v-if="!isgoods && !currentPrice">
                <span v-if="shoppingPrice">{{ "¥" + shoppingPrice }}</span>
              </div>
              <div class="bookPrice" v-if="isgoods && isHaveCatalog">
                <span>{{ "¥" + currentPrice }}</span>
                <span class="original" v-if="currentPrice != originalPrice">
                  {{ "¥" + originalPrice }}
                </span>
              </div>
              <div class="score_read" v-if="scoreNum > 0">
                <span>评分：</span>
                <el-rate
                  v-model="scoreNum"
                  disabled
                  show-score
                  :colors="colorArr"
                  text-color="#FF7B5B"
                  score-template="{value}"
                ></el-rate>
              </div>
            </div>
          </div>
        </div>
        <!-- pc 路由+全书购买+纸质书 -->
        <div class="OtherWrap_pc">
          <div class="otherLeft">
            <router-link to="/bookDetail/bookCatalog">
              {{ isHaveCatalog ? "目录" : "介绍" }}
            </router-link>
            <span @click="ToComment">评价</span>
          </div>
          <div class="otherRight">
            <!-- 纸质书二维码 -->
            <div v-if="QrImgsrc || QrURL">
              <a class="Qr-text" :href="QrURL ? QrURL : 'javascript:;'">
                <span></span>纸质书
              </a>
              <a
                class="Qr-img"
                v-if="QrImgsrc"
                :href="QrURL ? QrURL : 'javascript:;'"
              >
                <img :src="QrImgsrc" alt="" />
              </a>
            </div>
            <p v-if="isBuyAllBook && isHaveCatalog" @click="GoBookRead">
              <span></span>全书阅读
            </p>
            <!-- 加入购物车 -->
            <p
              v-if="isHaveCatalog && !isBuyAllBook"
              :class="isgoods ? 'nodisabledBook' : 'disabledBook'"
              @click="AllBookDownload('cart')"
            >
              <span></span>购买电子书
            </p>
            <!-- 直接购买 -->
            <!-- <p style="display: none;" :class="isgoods?'nodisabledBook':'disabledBook'" @click="AllBookDownload(zj)"><span></span>购买电子书</p> -->
          </div>
        </div>
        <!-- 目录+提示 mobile -->
        <div class="catalogText_mobile">
          <p>{{ isHaveCatalog ? "目录" : "介绍" }}</p>
          <a href="javascript: ;" @click="toGoPageFn">我的知识平台</a>
          <!-- <p class="tip"><span></span>每个章节都可进行免费试读</p> -->
        </div>
        <!-- 目录+评论 -->
        <router-view ref="catalogRef" />
        <div id="comment" v-if="showMobile">
          <Comment />
        </div>
        <!-- 缩略图 -->
        <Thumbnail v-if="showMobile" :id="InformationId" />
        <!-- 热门推荐 -->
        <HotRecommend
          v-if="showMobile"
          :swiper-num="5"
          :show-recommend="false"
        />
        <!-- 版本说明 -->
        <div class="statement">
          <p>免责声明</p>
          <p>
            本网“知识服务平台”栏目全部内容均由隧道网编译整理，文中出现的数据、参数等内容，仅供工程技术人员学习，并不作为施工技术指导，如因参考上述内容出现任何问题，均有个人负责，隧道网不承担责任；如文中翻译内容有误，敬请批评指正！上述内容，未经隧道网授权，不得转载、摘编或以其它方式使用上述作品。违反上述声明者，本网将保留追究其相关法律责任的权利，如有其他问题请与本网联系。
          </p>
        </div>
      </div>
      <!-- 右部分 -->
      <div class="rightContWrap" v-if="showMobile">
        <DetailOther />
      </div>
    </div>
    <!-- mobile 路由+全书购买+纸质书 Text -->
    <div class="OtherWrap_mobile">
      <router-link
        :to="{ path: '/bookComment', query: { InformationId: InformationId } }"
      >
        <span></span>评价
      </router-link>
      <a v-if="QrURL" :href="QrURL" class="MobileBuyBook" target="_blank">
        购买纸质版
      </a>
      <p
        v-if="isHaveCatalog && isBuyAllBook"
        @click="GoBookReadFn"
        class="allBookText"
      >
        <span></span>全书阅读
      </p>
      <!-- 加入购物车 -->
      <a
        v-if="isHaveCatalog && !isBuyAllBook"
        :style="QrURL ? 'width:3rem' : 'flex:1'"
        :class="isgoods ? 'nodisabledBook' : 'disabledBook'"
        href="javascript:;"
        @click="GoPaymentMob('cart', 1)"
        class="allBookText"
      >
        购买电子书
      </a>
      <!-- 直接购买 -->
      <!-- <a :class="isgoods?'nodisabledBook':'disabledBook'" href="javascript:;" @click="GoPaymentMob('zj',1)" class="allBookText" style="display: none;">购买电子书</a> -->
    </div>
    <!-- 查看更多简介 -->
    <div class="coverWrap" v-if="showMoreInfo" @click.self="closeMoreIntr">
      <div class="lookMoreInfo">
        <h6>简介</h6>
        <img :src="BookImgUrl" alt="" :onerror="defaultImg" />
        <h3>{{ BookTitle }}</h3>
        <p v-html="BookIntrAll"></p>
        <span @click="closeMoreIntr"></span>
      </div>
    </div>
    <!-- 加入购物车成功提示 -->
    <div v-if="showAddCartTip">
      <addCartSuccess
        :bookImgUrl="addCartInfo.imagePath"
        :bookTitle="addCartInfo.name"
        :chapterTitle="addCartInfo.informationTitle"
      />
    </div>
    <!-- 页脚 -->
    <BottomFooter v-if="showMobile" />
    <!-- 在线客服 -->
    <online-service />
  </div>
</template>

<script>
import common from "../../assets/js/common.js";
import addCartSuccess from "../../components/addCartSuccess.vue";
import TopHeader from "../../components/TopHeader.vue";
import Banner from "../../components/Banner.vue";
import DetailOther from "../../components/DetailOther.vue";
import Comment from "../../components/Comment.vue";
import HotRecommend from "../../components/HotRecommend.vue";
import Thumbnail from "../../components/Thumbnail.vue";
import BottomFooter from "../../components/BottomFooter.vue";
import OnlineService from "../../components/OnlineService.vue";

export default {
  data() {
    return {
      showMoreInfo: false, // 查看更多简介
      InformationId: undefined, // 情报id
      BookTitle: "", // 书本标题
      BookIntr: "", // 书本介绍部分
      BookIntrAll: "", // 书本介绍all
      BookImgUrl: "", // 书本图片url
      QrURL: "", // 二维码地址
      QrImgsrc: "", // 二维码图片地址
      currentPrice: 0, // 现价
      originalPrice: 0, // 原价
      shoppingPrice: 0, // 纸质书价格
      scoreNum: 0, // 评分
      colorArr: ["#FF7B5B", "#FF7B5B", "#FF7B5B"],
      showMoreText: false, // 是否显示更多(书本简介)
      showMobile: true, // 是否加载评论模板+pc右部分
      isBuyAllBook: false, // 是否已购买全书
      isgoods: false, // 是否是商品
      showAddCartTip: false, // 加入购物车成功提示
      addCartInfo: {},
      defaultImg:
        'this.src="' + require("../../assets/img/default_pic.png") + '"', // 默认封面
      formRouterInfo: {},
      isHaveCatalog: true // 是否有目录列表
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      if (from.name == "TunnelOnline") {
        vm.formRouterInfo.title = "隧说网事";
        vm.formRouterInfo.path = from.fullPath;
      } else if (from.name == "LatestUpdates") {
        vm.formRouterInfo.title = "最新更新";
        vm.formRouterInfo.path = from.fullPath;
      }
    });
  },
  mounted() {
    if (window.innerWidth >= 320 && window.innerWidth <= 1024) {
      this.showMobile = false;
    }
    // 获取情报id
    this.InformationId = this.$route.query.InformationId;
    // 情报简介
    this.GetBookIntr();
    // 关闭加入购物车成功的提示
    common.$on("closeTip", () => {
      this.showAddCartTip = false;
    });
    // 打开加入购物车提示(目录页$emit)
    common.$on("openTip", val => {
      this.addCartInfo = val;
      this.showAddCartTip = true;
    });
    // 关闭购物车提示
    common.$on("closeTip", () => {
      this.showAddCartTip = false;
    });

    // 是否有目录列表
    common.$on("catalogEvent", val => {
      this.isHaveCatalog = val;
    });
  },
  methods: {
    // 跳转页面
    toGoPageFn() {
      let isLogin = this.$refs.myHeader.getIsLoginVal();
      if (isLogin) {
        this.$router.push("/myBookList");
        return;
      }

      let nowHref = location.href;
      let href =
        "https://m.tunnelling.cn/Manager/Login.aspx?returnUrl=" +
        encodeURIComponent(nowHref);
      location.href = href;
    },
    // 获取书本介绍
    GetBookIntr() {
      this.$fetch("/api/information/" + this.InformationId)
        .then(res => {
          this.BookTitle = res.data.title;

          this.BookIntrAll = res.data.abstract;
          this.BookImgUrl = res.data.imagePath;
          this.currentPrice = res.data.currentPrice;
          this.originalPrice = res.data.originalPrice;
          this.shoppingPrice = res.data.shoppingPrice;
          this.isgoods = res.data.isGoods;
          this.isBuyAllBook = res.data.purchased;
          this.scoreNum = res.data.score;
          this.QrURL = res.data.bookStoreUrl;
          this.QrImgsrc = res.data.bookStoreQR;
          document.title = this.BookTitle + "-知识服务";
          this.updateWXShareInfo();
          this.JudgeShowMore();
        })
        .catch(err => {
          throw err;
        });
    },
    // 判断是否显示更多(书本介绍)
    JudgeShowMore() {
      let text = this.BookIntrAll;
      if (text == undefined) return;

      if (this.showMobile) {
        if (text.length > 250) {
          this.BookIntr = text.substring(0, 250) + "...";
          this.showMoreText = true;
        } else {
          this.BookIntr = text;
        }
        return;
      }

      if (text.length > 45) {
        this.BookIntr = text.substring(0, 45) + "...";
        this.showMoreText = true;
      } else {
        this.BookIntr = text;
      }
    },
    // 查看更多书本介绍
    openMoreIntr() {
      this.showMoreInfo = true;
    },
    // 关闭书本介绍
    closeMoreIntr(num) {
      this.showMoreInfo = false;
      if (num == 0) {
      } else {
        this.showTryRead = false;
      }
    },
    // pc-全书购买
    AllBookDownload(isCart) {
      if (!this.isgoods) return;

      this.$fetch("/Login")
        .then(res => {
          // 判断登陆状态
          if (res.data.accessAllowed === false) {
            this.LoginTip();
            return;
          }

          // 获取商品id并加入购物车
          if (isCart === "cart") {
            this.getGoodsIdFn(this.InformationId);
            return;
          }

          // *直接购买全书（暂时弃用）
          common.$emit("buyBook", "zj", 1);
        })
        .catch(err => {
          throw err;
        });
    },
    // 获取情报所对应的商品id
    getGoodsIdFn(id) {
      this.$fetch(`/api/information/goods?id=${id}`)
        .then(res => {
          // 商品信息
          this.addCartInfo = res.data;
          // 加入购物车
          this.addToCartFn(res.data.id);
        })
        .catch(errr => {
          throw err;
        });
    },
    // 加入购物车
    addToCartFn(goodsId) {
      this.$post("/api/ShoppingCarts", { goodsId: goodsId })
        .then(res => {
          // 获取购物车数量
          this.getCartCountFn();
          // 提示
          this.showAddCartTip = true;
        })
        .catch(err => {
          this.$message({
            message: err.response.data,
            type: "error",
            offset: 100
          });
        });
    },
    // 获取购物车数量
    getCartCountFn() {
      common.$emit("getCartNum");
    },
    // 判断是否登录
    LoginTip(param) {
      this.$confirm("此操作需登录后进行，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let nowHref = location.href;
        let href =
          "https://www.tunnelling.cn/PMember/MemberLogin.aspx?returnUrl=" +
          encodeURIComponent(nowHref);
        location.href = href;
      });
    },
    // 去支付(全书)--mobile
    GoPaymentMob(isCart, type) {
      if (!this.isgoods) return;

      this.$fetch("/Login")
        .then(res => {
          // 判断登陆状态
          if (res.data.accessAllowed === false) {
            this.LoginTip();
            return;
          }

          // 加入购物车 获取商品id
          if (isCart === "cart") {
            this.getGoodsIdFn(this.InformationId);
            return;
          }

          // 直接购买方式（暂时舍弃）
          // id 为本书的第一节id
          this.$router.push({
            name: "BookPayment",
            query: {
              type: type,
              InformationId: this.InformationId,
              chapterId: sessionStorage.getItem("firstPurchasedId")
            }
          });
        })
        .catch(err => {
          throw err;
        });
    },
    // pc-去全书阅读
    GoBookRead() {
      let routeData = this.$router.resolve({
        name: "BookRead",
        query: {
          InformationId: this.InformationId,
          id: sessionStorage.getItem("firstPurchasedId")
        }
      });
      window.open(routeData.href, "_blank");
    },
    // mobile-全书阅读
    GoBookReadFn() {
      this.$router.push({
        name: "BookRead",
        query: {
          InformationId: this.InformationId,
          id: sessionStorage.getItem("firstPurchasedId")
        }
      });
    },
    // 滑到评论
    ToComment() {
      document.querySelector("#comment").scrollIntoView(true);
    }
  },
  components: {
    TopHeader,
    Banner,
    DetailOther,
    Comment,
    HotRecommend,
    Thumbnail,
    BottomFooter,
    OnlineService,
    addCartSuccess
  }
};
</script>

<style scoped>
@import "./BookDetail.css";
</style>



// WEBPACK FOOTER //
// src/pages/BookDetails/BookDetail.vue